import { z } from 'zod';

import { companySchema } from 'entities/Company';
import { roleSchema, roleTextMap, Role } from 'types/Role';
import { createFullName } from 'utils/createFullName';

export const userRole = roleSchema;
export const USER_ROLES_ALL = new Set<UserRole>(userRole.options);

const nullishStringSchema = z.string().nullish();

export const userSchema = z
  .object({
    id: z.number(),
    first_name: z.string(),
    last_name: nullishStringSchema,
    patronymic: nullishStringSchema,
    phone: z.string(),
    email: z.string(),
    role: userRole,
    blocked: z.boolean(),
    unread_notices: z.number().optional(),
    is_content_editor: z.boolean(),
    company: companySchema,
    child_companies: z.array(companySchema).default([]),
  })
  .transform((raw) => {
    const lastName = raw.last_name ?? null;
    const patronymic = raw.patronymic ?? null;

    return {
      id: raw.id,
      firstName: raw.first_name,
      lastName,
      patronymic,
      fullName: createFullName({
        firstName: raw.first_name,
        lastName,
        patronymic,
      }),
      phone: raw.phone,
      email: raw.email,
      role: raw.role,
      roleLabel: roleTextMap[raw.role],
      blocked: raw.blocked,
      notificationsUnreadCount: raw.unread_notices ?? 0,
      isContentEditor: raw.is_content_editor,
      company: raw.company,
      childCompanies: raw.child_companies,
    };
  });

export type UserRole = Role;

export type UserEntityApi = z.input<typeof userSchema>;

export type UserEntity = z.infer<typeof userSchema>;

export type UserPersonalDataPatchApi = {
  first_name: string;
  last_name: string;
  patronymic: string | null;
  phone: string;
};
